<template>
  <div class="section">
    <div class="section_image">
      <!-- Preview de IMG -->
      <div class="" v-if="imageData[0] != undefined" style="position: relative; width: 12rem!important;">
        <div class="removeimage" v-if="configInputs == 0">
          <div class="closeimage" @click="resetFile(0)"></div>
        </div>
        <img class="container" :src="`${imageData[0]}`" id="fotoEmbalagemPreview"alt=""
         @click="clickPreview(imageData[0])" />
      </div>

      <div class="image-preview" v-else>
        <div v-if="configInputs==0">
          <input type="file" accept="image/*" id="fotoEmbalagem" @change="previewFiles($event, 0)" multiple hidden />
          <label class="palavra" for="fotoEmbalagem">
            <div class="palavra1"></div>
          </label>
        </div>
        <div v-else>
          <div class="empty"></div>
        </div>
      </div>
      <!--  -->

      <div class="">
        <!-- <div class="icons" v-if="configInputs == 0"></div> -->
        <p class="title">Embalagem externa</p>
      </div>
    </div>


    <div class="section_image">
      <!-- Preview de IMG -->
      <div class="image-preview" v-if="imageData[1] != undefined"
        style="position: relative; width: 12rem!important;">
        <div class="removeimage" v-if="configInputs == 0">
          <div class="closeimage" @click="resetFile(1)"></div>
        </div>
        <img class="container" :src="`${imageData[1]}`" id="fotoEmbalagemPreview" alt=""
          @click="clickPreview(imageData[1])" />
      </div>

      <div class="image-preview" v-else>
        <div v-if="configInputs==0">
          <input type="file" accept="image/*" id="fotoEmbalagem1" @change="previewFiles($event, 1)" multiple hidden />
          <label class="palavra" for="fotoEmbalagem1">
            <div class="palavra1"></div>
          </label>
        </div>
        <div v-else>
          <div class="empty"></div>
        </div>
      </div>
      <!--  -->

      <div>
        <p class="title">Embalagem interna</p>
        <!-- <div class="icons"  v-if="configInputs == 0">
        </div> -->
      </div>
    </div>

    <div class="section_image" style="text-align: center!important;">
      <!-- Preview de IMG -->
      <div class="image-preview" v-if="imageData[2] != undefined">
        <div class="removeimage" v-if="configInputs == 0">
          <div class="closeimage" @click="resetFile(2)"></div>
        </div>
        <img class="container" :src="`${imageData[2]}`" @click="clickPreview(imageData[2])"
          id="fotoEmbalagemPreview"/>
      </div>

      <div class="image-preview" v-else>
        <div v-if="configInputs==0">
          <input type="file" accept="image/*" id="fotoEmbalagem2" @change="previewFiles($event, 2)" multiple hidden />
          <label class="palavra" for="fotoEmbalagem2">
            <div class="palavra1"></div>
          </label>
        </div>
        <div v-else>
          <div class="empty"></div>
        </div>
      </div>
      <!--  -->

      <div class="card-body">
        <div v-if="configInputs == 0">
          <input type="text" class="extra-input" v-model="FormDataImages.fotoEmbalgemExtra.description" placeholder="Insira um título" />
        </div>
        <div v-else>
          <p class="title" v-if="!FormDataImages.fotoEmbalgemExtra.description">Extra</p>
          <p class="title" v-else>{{ FormDataImages.fotoEmbalgemExtra.description }}</p>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputI1 from "../../../../../Inputs-defaults/Inp-1.vue";
export default {
  components: { InputI1 },

  props: {
    configInputs: Number,
  },
  async created() {
    if (this.configInputs != 0) {
      await this.ConstructViewRRIM();
    }
  },
  data() {
    return {
      fotoEmbalagem: [],
      imageData: [],
      FormDataImages: {
        fotoEmbalagemE: [],
        fotoEmbalagemI: [],
        fotoEmbalgemExtra: {
          file: [],
          description: "",
        },
      },
    };
  },
  watch: {
    FormDataImages: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        this.$store.commit("MutationImagesAberturaEmbalagem", newValue);
      },
    },
  },
  methods: {
    clickPreview(base64) {
      this.$swal.fire({
          imageUrl: base64,
          imageAlt: "Imagem carregada",
          confirmButtonText: 'Baixar',
          showCloseButton: true,
          background: "#fff",
         customClass: {
            popup: 'preview-modal-popup',
            image: 'preview-modal-image',
            confirmButton: 'preview-modal-button'
  },
        }).then((result) => {
          if (result.isConfirmed) {
            const link = document.createElement('a');
            link.href = base64;
            link.download = 'imagem.jpg'; 
            link.click();
          }
      });
    },
    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;
      if (dataQuery.ImagesRRIM[0].IMG_EMB_EXT) {
        this.imageData[0] =
          `${this.$store.state.ImgURL}` + `${dataQuery.ImagesRRIM[0].IMG_EMB_EXT}`;
      }

      if (dataQuery.ImagesRRIM[0].IMG_EMB_INT) {
        this.imageData[1] =
          `${this.$store.state.ImgURL}` + `${dataQuery.ImagesRRIM[0].IMG_EMB_INT}`;
      }

      if (dataQuery.ImagesRRIM[0].IMG_EMB_EXTRA) {
        this.imageData[2] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_EMB_EXTRA}`;
      }

      if (dataQuery.ImagesRRIM[0].IMG_EMB_EXTRA_DESC) {
        this.FormDataImages.fotoEmbalgemExtra.description =
          dataQuery.ImagesRRIM[0].IMG_EMB_EXTRA_DESC;
      }
    },
    previewFiles(event, position) {
          const input = event.target;

      if (input.files && input.files[0]) {
        const file = input.files[0];
        
        if (!file.type.startsWith("image/")) {
          this.$swal.fire({
            icon: "error",
            title: "Arquivo inválido",
            text: "Por favor, selecione apenas arquivos de imagem.",
            confirmButtonColor: "#e74c3c",
          });
          input.value = ""; 
          return;
        }
        switch (position) {
          case 0:
            this.FormDataImages.fotoEmbalagemE = file;
            break;
          case 1:
            this.FormDataImages.fotoEmbalagemI = file;
            break;
          case 2:
            this.FormDataImages.fotoEmbalgemExtra.file = file;
            break;
        }
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageData[position] = e.target.result;
        };
        reader.readAsDataURL(file);
  }
    },
    resetFile(position) {
      this.imageData[position] = null;

      switch (position) {
        case 0:
          this.FormDataImages.fotoEmbalagemE = [];
          break;
        case 1:
          this.FormDataImages.fotoEmbalagemI = [];
          break;
        case 2:
          this.FormDataImages.fotoEmbalgemExtra.file = [];
          this.FormDataImages.fotoEmbalgemExtra.description = "";
          break;
      }

    },
  },
};
</script>

<style>


.swal2-popup.preview-modal-popup {
  height: 90vh !important;
  width: auto;
  max-width: 90vw;
  padding: 0.5rem 1.5rem !important;
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 1rem;
}
.swal2-image.preview-modal-image {
  max-width: 100%;
  max-height: 80%;
  height: 80%;
  width: auto;
  object-fit: contain;
  margin-bottom: 1rem;
  border-radius: 1rem;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
}

.swal2-confirm.preview-modal-button {
  margin-top: auto;
  padding: 0.5rem 1.2rem;
  font-weight: 600;
  border-radius: 0.5rem;
  background-color: var(--font_color);
  width: 8rem;
}

.swal2-confirm.preview-modal-button:hover {
  color: var(--font_color);
  background-color: white;
}


.swal2-close {
  position: absolute !important;
  top: 0.2rem !important;
  right: 1rem !important;
  z-index: 10;
}

</style>

<style scoped>

.container {
  cursor: pointer;
}

.image-preview,
.palavra1,
#fotoEmbalagemPreview {
  width: 12rem !important;
  height: 12rem !important;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  overflow: hidden;
}

#fotoEmbalagemPreview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 1rem;
}

.section {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  flex-wrap:wrap;
  gap: 2rem;
}

.section_image {
  display: inline-block;
  max-width: 11rem!important;
}

.title {
  font-size: 0.7rem;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
  margin-top: 0.5rem;

}

.palavra {
  width: 12rem !important;
}

.palavra1 {
  background-color: var(--bgProcess);
  background-image: url(../../../../../../static/icons/+_black.svg);
  width: 12rem !important;
  height: 12rem !important;
  border-radius: 1rem;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 15%;
}

.palavra1:hover{
  background-color: rgb(156, 150, 150);
}

.image-preview {
  position: relative;
}

.removeimage {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 3;
  cursor: pointer;
}

#fotoEmbalagemPreview {
  position: relative;
  z-index: 2;
  border-radius: 1rem;
}

.closeimage {
  width: 24px;
  height: 24px;
  background: url(../../../../../../static/icons/closeimage.svg) no-repeat center;
  background-size: contain;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
  cursor: pointer;
}

.extra-input {
  border: 2px solid var(--bgProcess)!important;
  background-color: rgba(255, 255, 255, 0);
  padding: 0.3rem!important;
  height: 2rem!important;
  margin: 1rem auto!important;
  color: var(--font_color);
  font-weight: 600;
  font-family: 'Poppins', 'sans-serif';
  border-radius: 0.5rem;
  max-width: 92%;
}

.extra-input:hover {
  border: 2px solid var(--graydark)!important;
  transition: 1s;
}

.extra-input:focus{
  border: 2px solid var(--font_color)!important;
  transition: 1s;
}


.empty {
  background-image: url('../../../../../../static/icons/empty-image.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 40%;
  width: 12rem;
  height: 12rem;
  border: 2px solid #757575;
  border-radius: 1rem;
}

@media (max-width: 1266px) {
  .image-preview,
  .palavra1,
  #fotoEmbalagemPreview, .empty {
    width:11rem!important;
    height:11em!important;
  }

}

@media(max-width: 883px){

}


@media (max-width: 500px) {
  .image-preview,
  .palavra1,
  #fotoEmbalagemPreview {
    width:12rem!important;
    height:12rem!important;
  }

}
</style>
